import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import Button, {} from '@helsenorge/designsystem-react/components/Button';
import styles from './styles.module.scss';
const FeedbackButton = props => {
    const { feedbackButtonVariant, variant, ...rest } = props;
    const usedVariant = variant || feedbackButtonVariant || 'fill';
    const buttonClassName = classNames(styles[`feedbackbutton--${usedVariant}`], {
        [styles['feedbackbutton__floating-wrapper']]: usedVariant === 'floating',
    });
    return _jsx(Button, { ...rest, className: buttonClassName, variant: usedVariant !== 'floating' ? usedVariant : 'outline' });
};
export default FeedbackButton;
